// Google Analytics loader — Jun 2026. Silent: injects gtag only when a
// measurement ID (G-XXXX) is configured via REACT_APP_GA_MEASUREMENT_ID.
export const initGA = () => {
  try {
    const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!id || !id.startsWith('G-') || window.__mespGA) return;
    window.__mespGA = true;
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', id, { anonymize_ip: true });
  } catch (_e) { /* never break the app over analytics */ }
};
